import React, { useState, useEffect, Suspense } from "react";
import '../App.css';
import Header from "./c/Header";
import Footer from "./c/Footer";
import { useParams } from "react-router-dom";

import apiUrl from "../lib/api";
import apiHeader from "../lib/apiHeader";

import { useFooter } from "../lib/varFooter";
import { useComposer } from "../lib/varComposer";
import { useHeader } from "../lib/varHeader";

import ComposerDetail from "./c/ComposerDetail";

const Composer: React.FC = () => {
    let { composerID } = useParams();

    const { setFooter } = useFooter();
    const { setComposerData } = useComposer();
    const { setHeader } = useHeader();
    const { composerData } = useComposer();

    async function fetchComposerInfo() {
        try {
            const dataToSend = {
                topic: 'credits',
                person: composerID,
            }
            const result = await fetch(apiUrl,{method: "POST", headers: apiHeader, body: JSON.stringify(dataToSend)})
            const datafromresult = await result.json();
            setComposerData((prev) => ({ ...prev, ...datafromresult['data'][0]}))
            const header = {
                current_composer_id: composerID,
            }
            setHeader((prev) => ({...prev, ...header}))
            const footer = {
                api_version: datafromresult['version'],
                api_license: datafromresult['license'],
                api_license_url: datafromresult['license_url'],
                api_attribution: datafromresult['attribution'],
                api_server_name: datafromresult['servername'],
                api_server_time: datafromresult['time'],
            }
            setFooter((prev) => ({ ...prev, ...footer}))
        } catch (error) {
            console.log('fetchComposerInfo() ERROR => ', error)
        }
    }

    useEffect(() => {
        fetchComposerInfo();
    }, [composerID])

    return (
        <div className="App">
            <Header />
            {composerData ? <Suspense fallback={<div>Loading...</div>}><ComposerDetail personData={composerData} myRegion={""} searchRegion={""} /></Suspense> : null}
            <Footer />
        </div>
    )
}

export default Composer;
